module.exports = __webpack_public_path__ + "images/fa-footer-reviews-testimonials-page.webp";